import React, { useEffect, useState } from 'react'
import { Button, Col, Row, } from 'react-bootstrap'
import Add from '@mui/icons-material/Add';

import FilterAltRoundedIcon from '@mui/icons-material/FilterAltRounded';
import CustomTextFeild from '../common/CustomTextFeild'
import CustomButton from '../common/CustomButton';
import Search from '../assets/images/search.png'
import WhiteSearch from '../assets/images/whitesearch.png'
import { FaWallet, FaUsers } from 'react-icons/fa';
import { apiRequest } from '../utils/config/apiRequest';
import { _apiUrls } from '../utils/endpoints/apiUrls';
import EditIcon from '@mui/icons-material/Edit';
// import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Pagination from '../common/Pagination';
import CustomModal from '../common/CustomModal';
import Flag from '../assets/images/flag.png'
import { useNavigate } from 'react-router-dom';
import CustomSelect from '../common/CustomSelect';
import CustomTooltip from '../common/CustomTooltip';
import { useSelector } from 'react-redux';
import { getTheme } from '../redux/selectors/appSelectors';
import ColorPicker from './FetchColorData';

export default function Category() {

  const theme = useSelector(getTheme);
  const isDarkMode = theme === 'dark';
  const navigate = useNavigate()

  const categories = [
    { icon: <FaWallet />, label: 'General' },
    { icon: <i className="fa fa-percent fonticon" aria-hidden="true"></i>, label: 'Discounts' },
    { icon: <i className="fa fa-star-o fonticon" aria-hidden="true"></i>, label: 'Bonuses' },
    { icon: <i className="fa fa-gift fonticon" aria-hidden="true"></i>, label: 'Special Offers' },
    { icon: <FaUsers />, label: 'Volunteering' },
    { icon: <i className="fa fa-id-card-o fonticon" aria-hidden="true"></i>, label: 'Student Works' },
    { icon: <i className="fa fa-percent fonticon" aria-hidden="true"></i>, label: 'Fashion' },
    { icon: <i className="fa fa-medkit fonticon" aria-hidden="true"></i>, label: 'Beauty & Health' },
    { icon: <i className="fa fa-cutlery fonticon" aria-hidden="true"></i>, label: 'Food & Drinks' },
    { icon: <i className="fa fa-television fonticon" aria-hidden="true"></i>, label: 'Electronics' },
    { icon: <i className="fa fa-music fonticon" aria-hidden="true"></i>, label: 'Entertainment' },
    { icon: <i className="fa fa-plane fonticon" aria-hidden="true"></i>, label: 'Travel' },
    { icon: <i className="fa fa-calendar-o fonticon" aria-hidden="true"></i>, label: 'Events' },
    { icon: <i className="fa fa-home fonticon" aria-hidden="true"></i>, label: 'Home & Garden' },
    { icon: <i className="fa fa-trophy fonticon" aria-hidden="true"></i>, label: 'Trophy' },
    { icon: <i className="fa fa-paw fonticon" aria-hidden="true"></i>, label: 'Toys' },
    { icon: <i className="fa fa-percent fonticon" aria-hidden="true"></i>, label: 'Pet Services' },
    { icon: <i className="fa fa-car fonticon" aria-hidden="true"></i>, label: 'Gas Stations' },
    { icon: <i className="fa fa-graduation-cap fonticon" aria-hidden="true"></i>, label: 'Automotive Services' },
    { icon: <i className="fa fa-briefcase fonticon" aria-hidden="true"></i>, label: 'Jobs & Careers' },
    { icon: <i className="fa fa-headphones fonticon" aria-hidden="true"></i>, label: 'Online Services' },
    { icon: <i className="fa fa-tachometer fonticon" aria-hidden="true"></i>, label: 'Technology & Gadgets' },
    { icon: <i className="fa fa-paint-brush fonticon" aria-hidden="true"></i>, label: 'Art & Culture' },
  ];

  const [loading, setLoading] = useState(false);
  const [state, setState] = useState({ rows: [] });
  const [searchText, setSearchText] = useState('');

  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const itemsPerPage = 10;

  // Filter States -----------------------------------------------

  const [filtersCleared, setFiltersCleared] = useState(false);
  const [filterOptions, setFilterOptions] = useState({
    category: [],
  });

  const [filters, setFilters] = useState({
    country: '',
  });

  const fetchCategory = async () => {
    setLoading(true);
    const { data, status } = await apiRequest({
      endUrl: _apiUrls.getCategory,
      method: 'GET',
      query: {
        search: searchText,
        page: currentPage,
        limit: itemsPerPage,
        ...filters
      }
    })
    setLoading(false);
    if (status) {
      setState({ ...state, rows: Array.isArray(data?.rows) ? data.rows : [] })
      setTotalItems(data?.count || 0);
    }
  };

  useEffect(() => {
    fetchCategory();
  }, [currentPage, searchText])

  const [filterModal, setFilterModal] = useState(false);

  // Delete Category -----------------------------------------

  const [modalShow, setModalShow] = useState(false);
  const [modalState, setModalState] = useState({ name: '', user: null })

  const handleModalAction = (type, user) => {
    setModalState({ name: type, user });
    setModalShow(true);
  };

  const confirmDelete = async () => {
    const user = modalState?.user
    if (!user) return
    const { status, message } = await apiRequest({
      endUrl: _apiUrls.deleteCategory,
      method: 'DELETE',
      query: { categoryId: user._id },
      showMsg: true
    })
    if (status) {
      fetchCategory();
    }
    setModalShow(false)
    setModalState({ name: '', user: null })
  }


  // Show and Hide All Table ----------------------------------------------
  const [showTable, setShowTable] = useState(false);
  const handleViewToggle = () => {
    setShowTable(true);
  };

  const displayedRows = showTable ? state.rows : state.rows.slice(0, 3);

  // Filter function ------------------------------

  const fetchFilterOptions = async () => {
    const types = ['category',];
    const results = {};
    for (const type of types) {
      const { data, status } = await apiRequest({
        endUrl: _apiUrls.filterNotification,
        method: 'GET',
        query: { filterType: type }
      });

      if (status && Array.isArray(data?.rows)) {
        results[type] = data.rows.map(val => ({
          label: val?.toString(),
          value: val?.toString()
        }));
      } else {
        results[type] = [];
      }
    }

    setFilterOptions(results);
  };

  const clearFilters = () => {
    setFilters({
      country: '',
    });
    setFiltersCleared(true); // ✅ mark that filters were cleared
  };

  useEffect(() => {
    if (filtersCleared) {
      fetchCategory();           // ✅ run fetch after filters are cleared
      setFiltersCleared(false); // reset flag
    }
  }, [filtersCleared, currentPage]);



  return (
    <>
      <Row>
        <Col md={12} className='py-3'>
          <h4 className='dashheading'>Manage Category/Background</h4>
          <p className='dashsubheading'>
            Showing 1 to 10 of 57 list
          </p>
        </Col>
      </Row>

      <Row>
        <Col md={9} xs={12} className='pb-3'>
          <div className="scroll-buttons-container">
            <div className="d-flex gap-3">
              <CustomButton variant="contained"
                text={"Add More"}
                iconLeft={<Add style={{ fontSize: 18 }} />}
                className='containebtn'
                onClick={() => navigate('/dashboard/addcategory')}
              />

              <CustomButton variant="contained"
                text="Filter"
                iconLeft={<FilterAltRoundedIcon style={{ fontSize: 18 }} />}
                className='containebtn'
                onClick={() => {
                  setFilterModal(true)
                  fetchFilterOptions();
                }}
              />

              <CustomButton variant="outline2"
                onClick={clearFilters}
                text="Clear Filters"
                className='outline2-btn'
              />
            </div>
          </div>
        </Col>

        <Col md={3} xs={12} className='pb-3'>
          <CustomTextFeild style={{
            padding: " 7px 13px",
            borderRadius: "10px", height: "auto",
          }}
            icon={isDarkMode ? WhiteSearch : Search}
            iconHeight="15px"
            placeholder='Search Content'
            value={searchText}
            // onChange={(e) => setSearchText(e.target.value)}
            onChange={(e) => {
              const value = e.target.value;
              setSearchText(value);
              if (value === '') {
                setCurrentPage(1);
              }
            }}
          />
        </Col>

        <Col md={12} className='mt-2'>
          <div className="head-border" />
        </Col>

        <Col md={12} className='mt-4 pb-2'>
          <h2 className='cat-heading'>Category</h2>
        </Col>
      </Row>


      {/* <Row className='noflexwrap'>
        {categories.map((item, index) => (
          <Col md={2} xs={6} className='me-0 pe-sm-0'>
            <div key={index} className="category-card me-2">
              <div className="category-icon">{item.icon}</div>
              <div className="category-label">{item.label}</div>
            </div>
          </Col>
        ))}
      </Row> */}

      <Row className='noflexwrap'>
        {state.rows.length > 0 ? (
          state.rows.map((item, index) => (
            <Col md={2} xs={6} className='me-0 pe-sm-0' key={item?._id || index}>

              <div className="category-card me-2">
                <div className="category-icon">
                  {item?.categoryIcons ? (
                    <img
                      src={`${process.env.REACT_APP_API_ORIGIN}/${item?.categoryIcons?.replace(/^\/+/, "")}`}
                      alt={""}
                      style={{ width: 40, height: 40, borderRadius: '50%' }}
                    />
                  ) : (
                    <i className="fa fa-folder-open fonticon" aria-hidden="true"></i>
                  )}
                </div>
                <div className="category-label mt-1">{item?.categoryName || "Unnamed"}</div>
              </div>
            </Col>
          ))
        ) : (
          <Col md={12} className="text-center">
            <p>No categories found.</p>
          </Col>
        )}
      </Row>

      <Row>
        <Col md={12} className='mt-4 pb-2'>
          <div className="table-responsive">
            <table className='admintable'>
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Category</th>
                  <th>Category Icons</th>
                  <th>Discription</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="7" className="text-center py-4">
                      <div className="d-flex justify-content-center align-items-center">
                        <div className="spinner-border text-primary" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    </td>
                  </tr>
                ) : (
                  displayedRows.length > 0 ? (
                    displayedRows.map((item, index) => (
                      <tr key={item?._id || index}>
                        <td>{index + 1}</td>
                        <td>{item?.categoryName || "----"}</td>
                        <td>
                          {item?.categoryIcons ? (
                            <>
                              {(() => {
                                const fullImageUrl = `${process.env.REACT_APP_API_ORIGIN}/${item?.categoryIcons?.replace(/^\/+/, "")}`;
                                return (
                                  <img
                                    src={fullImageUrl}
                                    alt=""
                                    style={{ width: 40, height: 40, borderRadius: '50%' }}
                                  />
                                );
                              })()}
                            </>
                          ) : (
                            <p className="mb-0 no-data-found">-----</p>
                          )}
                        </td>
                        <td>{item?.description || "----"}</td>
                        <td>
                          <span className={`badge badge-status ${item?.status === 'active' ? 'bg-success' : 'badge-danger'}`}>
                            {item?.status?.charAt(0).toUpperCase() + item?.status?.slice(1)}
                          </span>
                        </td>
                        <td>
                          <div className="gap-2 d-flex align-items-center">
                            <CustomTooltip title="Edit">
                              <p className='mb-0'
                                onClick={() => navigate(`/dashboard/addcategory/${item?._id}`)}
                                style={{ textDecoration: 'none' }}>
                                <EditIcon sx={{ color: isDarkMode ? 'rgba(75, 128, 235, 1)' : '#2C2C2C', cursor: 'pointer', fontSize: 18 }} />
                              </p>
                            </CustomTooltip>

                            <CustomTooltip title="View">
                              <VisibilityIcon
                                onClick={() => handleModalAction('view', item)}
                                sx={{ color: 'rgba(75, 128, 235, 1)', cursor: 'pointer', fontSize: 18 }} />
                            </CustomTooltip>

                            {/* <CustomTooltip title="Delete">
                              <DeleteIcon
                                onClick={() => handleModalAction('delete', item)}
                                sx={{ color: '#F57171', cursor: 'pointer', fontSize: 18 }} />
                            </CustomTooltip> */}
                          </div>
                        </td>
                      </tr>
                    ))) : (
                    <tr>
                      <td colSpan="7" className="text-center py-4">
                        <p className='textwhite f-14 mb-0'>
                          No records found.
                        </p>
                      </td>
                    </tr>
                  )
                )}
              </tbody>
            </table>
          </div>
        </Col>

        <Col md={10}>
          <p className='tablebottomText'> <img src={Flag} height="18px" alt="" className='me-1' /> Russian user data is processed and stored in accordance with the legal requirements of the Russian Federation (Federal Law No. 152-FZ).</p>
        </Col>

        <Col md={2} className='text-end mt-3'>
          <Button variant="secondary"
            onClick={handleViewToggle}
            style={{
              background: 'rgba(75, 128, 235, 1)',
              borderColor: "rgba(75, 128, 235, 1)",
              padding: "5px 19px",
              borderRadius: "7px",
              fontSize: 13
            }}>
            View Full List
          </Button>
        </Col>

        <ColorPicker />

        <Col md={12} className='text-end mt-3'>
          <div className="d-flex justify-content-end">
            <Pagination
              totalItems={totalItems}
              itemsPerPage={itemsPerPage}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </Col>

      </Row>


      {/* Filter Modal -------------------------------- */}

      <CustomModal
        show={filterModal}
        onHide={() => {
          setFilterModal(false);
        }}
        title="List of Content"
        subtitle="Filter"
        showCloseButton={true}
        footerButtons={
          <>
            <div style={{ display: 'flex', marginTop: 10, justifyContent: 'flex-start', gap: '10px', width: '100%' }}>
              <Button variant="secondary"
                style={{
                  backgroundColor: "rgba(75, 128, 235, 1)",
                  borderColor: "rgba(75, 128, 235, 1)",
                  padding: "8px 30px",
                  borderRadius: 10
                }}
                onClick={() => {
                  setFilterModal(false);
                  fetchCategory();
                }}>
                Apply Filters
              </Button>
            </div>
          </>
        }
      >

        <Row className='mt-3'>
          <Col md={12}>
            <p className='mb-1 input-label f-14'>Select Name</p>
            <CustomSelect
              options={filterOptions?.category}
              value={filters.category}
              onChange={(option) => setFilters(prev => ({ ...prev, category: option.value }))}
            />
          </Col>
        </Row>

      </CustomModal>

      {/* Delete Modal -------------------------------------------- */}

      <CustomModal
        show={modalShow}
        onHide={() => {
          setModalShow(false);
          setModalState({ name: '', user: null });
        }}
        title={modalState.name === 'delete' ? 'Confirm Deletion' : 'Category Details'}
        showCloseButton={true}
        footerButtons={
          <>
            {modalState?.name === 'delete' && (
              <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', width: '100%' }}>
                <Button variant="secondary" style={{ padding: "5px 30px" }} onClick={() => {
                  setModalShow(false)
                  setModalState({ name: '', user: null })
                }}>
                  Cancel
                </Button>
                <Button variant="danger" style={{ padding: "5px 30px" }} onClick={confirmDelete}>
                  Delete
                </Button>
              </div>
            )}
          </>
        }
      >
        {modalState?.name === 'delete' && (
          <p className='my-4 text-center textwhite' style={{ fontSize: 18 }}>
            Are you sure you want to delete <strong>{modalState?.user?.categoryName}</strong>?
          </p>
        )}

        {modalState?.name === 'view' && modalState?.user && (
          <Row className='mt-2'>
            <Col md={6}>
              <div className='text-start'>
                <p className='f-16 input-label mb-0'><strong>Name:</strong></p>
                <p className='f-16 input-label'>{modalState?.user?.categoryName}</p>
              </div>
            </Col>
            <Col md={6}>
              <div className='text-start'>
                <p className='f-16 input-label mb-0'><strong>Status:</strong></p>
                <p className='f-16 input-label'>{modalState?.user?.status}</p>
              </div>
            </Col>
            <Col md={6}>
              <div className='text-start'>
                <p className='f-16 input-label mb-0'><strong>Description:</strong></p>
                <p className='f-16 input-label mb-0'>{modalState?.user?.description}</p>
              </div>
            </Col>
            <Col md={6}>
              <div className='text-start'>
                <p className='f-16 input-label mb-1'><strong>Category Icon:</strong></p>
                {modalState.user?.categoryIcons && (
                  <img
                    src={`${process.env.REACT_APP_API_ORIGIN}/${modalState.user?.categoryIcons?.replace(/^\/+/, "")}`}
                    alt=""
                    style={{ width: 80, height: 80, borderRadius: '10%' }}
                  />
                )}
              </div>
            </Col>
          </Row>
        )}
      </CustomModal>



    </>
  )
}

